import { render, staticRenderFns } from "./accreditation-form.vue?vue&type=template&id=5280d852&scoped=true"
import script from "./accreditation-form.vue?vue&type=script&lang=js"
export * from "./accreditation-form.vue?vue&type=script&lang=js"
import style0 from "./accreditation-form.vue?vue&type=style&index=0&id=5280d852&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5280d852",
  null
  
)

export default component.exports